import React, { useEffect } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
  Linking,
  Share,
} from "react-native";
//import FastImage from 'react-native-fast-image';
import { useDispatch } from "react-redux";
import { Color, globalFontStyle } from "../../../assets";
import {
  hideLoader,
  showLoader,
} from "../../../commonComponents/Loader/loader.actions";
import { share_white } from "../../../utils/images";
import { trackMoengageEvent } from "../../../utils/commonMethods";
import {globalConfigurableData, globalConst} from "../../../utils/globalConstant";
import { Icon } from '@iconify/react';

const ClubOwnerDetails = ({ club, isMember }) => {
  const clickSocialHandles = () => {
    trackMoengageEvent("Click Social Handles", {
      link: club?.community_url,
    });
    if (club?.community_url) {
      Linking.openURL(club?.community_url);
    }
  };

  const dispatch = useDispatch();

  const shareClubLink = async () => {
    trackMoengageEvent("Club link share", {
      link: club?.shareable_url,
    });
    dispatch(showLoader());
    var msg =
      "Inviting you to join private club " +
      club?.title +
      " on " +
      globalConfigurableData?.appName +
      " with me. We can trade on events together and can participate in various tournaments. \nInvitation Link: " +
      club?.shareable_url;
    Share.share({
      message: msg,
    }).then(() => {
      dispatch(hideLoader());
    });
  };
  return (
    <View style={styles.clubOwnerInfoContainer}>
      <Text
        style={{ marginBottom: 30, textAlign: "center", color: Color.black }}
      >
        {club?.description}
      </Text>
      <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
        {isMember && (
          <TouchableOpacity
            style={[styles.joinBlkStyle1, { backgroundColor: Color.bgWhite }]}
            onPress={clickSocialHandles}
          >
            <Text>{club?.join_discussion_text}</Text>
          </TouchableOpacity>
        )}
        <TouchableOpacity
          style={[
            styles.joinBlkStyle,
            styles.shareBlkStyle,
            { flexDirection: "row" },
          ]}
          onPress={shareClubLink}
        >
          <Text style={styles.shareTxtStyle}>Share Club Link</Text>
          <TouchableOpacity style={{ padding: 5 }}>
            <Icon 
              icon="tabler:share-2"
              style={{ width: 24, height: 24 }}
              color="#FFFFFF"
            />
          </TouchableOpacity>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default ClubOwnerDetails;

const styles = StyleSheet.create({
  clubOwnerInfoContainer: {
    paddingHorizontal: 12,
    paddingVertical: 20,
    backgroundColor: Color.grey5,
    marginHorizontal: -12,
  },
  joinBlkStyle1: {
    paddingHorizontal: 32,
    paddingVertical: 10,
    borderWidth: 0.75,
    borderRadius: 8,
    borderColor: "#0A57FF",
  },
  joinBlkStyle: {
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderWidth: 0.75,
    borderRadius: 8,
    borderColor: "#0A57FF",
  },
  shareBlkStyle: {
    backgroundColor: Color.blue1,
    alignSelf: "center",
  },
  shareTxtStyle: {
    ...globalFontStyle.appFontSmallText,
    color: Color.bgWhite,
  },
  backStyle: {
    width: 15,
    height: 15,
  },
});
